var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-locations-create"},[_c('BreadCrumb'),_c('h1',[_vm._v(" Add New Location ")]),_c('FormCreate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }